<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="paddingContent">
      <div class="activityDrawListHeader">
        <el-popover
          placement="top-start"
          title=""
          width="200"
          trigger="hover"
          :content="drawDetail.applyName"
          v-if="drawDetail.applyName.length > 40"
        >
          <div class="activityDrawListHeader_title" slot="reference">
            {{ drawDetail.applyName }}
          </div>
        </el-popover>
        <div class="activityDrawListHeader_title" slot="reference" v-else>
          {{ drawDetail.applyName }}
        </div>
        <div class="activityDrawListHeader_detail">
          <div class="activityDrawListHeader_detail_key">
            活動状态：
          </div>
          <div class="activityDrawListHeader_detail_value">
            {{
              drawDetail.applyStatus == "1"
                ? "未開始階段"
                : drawDetail.applyStatus == "2"
                ? "報名階段"
                : drawDetail.applyStatus == "3"
                ? "抽籤階段"
                : drawDetail.applyStatus == "4"
                ? "付款階段"
                : drawDetail.applyStatus == "5"
                ? "確認階段"
                : ""
            }}
          </div>
          <div class="activityDrawListHeader_detail_key">
            活動类型：
          </div>
          <div class="activityDrawListHeader_detail_value">
            {{
              drawDetail.applyWay == "1"
                ? "一般活動"
                : drawDetail.applyWay == "2"
                ? "演唱會"
                : drawDetail.applyWay == "4"
                ? "見面會"
                : drawDetail.applyWay == "3"
                ? "後臺活動"
                : ""
            }}
          </div>
          <div
            class="activityDrawListHeader_detail_key"
            v-if="this.drawDetail.free == 1"
          >
            付費活動：
          </div>
          <div class="activityDrawListHeader_detail_value">
            {{ this.drawDetail.free == 1 ? "是" : "" }}
          </div>
          <div v-if="this.drawDetail.free == 1" style="display: flex;">
            <div class="activityDrawListHeader_detail_key">
              活動地點：
            </div>
            <div class="activityDrawListHeader_detail_value">
              {{ this.drawDetail.land == 0 ? "大陸" : "海外" }}
            </div>
          </div>
          <div class="activityDrawListHeader_detail_key">
            登記人數：
          </div>
          <div class="activityDrawListHeader_detail_value">
            {{ drawDetail.registration ? drawDetail.registration : 0 }}
          </div>
          <div class="activityDrawListHeader_detail_key">
            活動名額數：
          </div>
          <div class="activityDrawListHeader_detail_value">
            {{ drawDetail.totalNum ? drawDetail.totalNum : 0 }}
          </div>
        </div>
      </div>
      <el-tabs v-model="activeTab">
        <el-tab-pane :label="'已抽中' + drawDetail.beSelectedNumber" name="1">
          <ActivityConfirmVue @dataBack="dataBack" v-if="activeTab == 1" />
        </el-tab-pane>
        <el-tab-pane :label="'未抽中' + drawDetail.notSelectedNumber" name="2">
          <ActivityConfirmNullVue @dataBack="dataBack" v-if="activeTab == 2" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import ActivityConfirmVue from "@/components/activityConfirm.vue";
import ActivityConfirmNullVue from "@/components/activityConfirmNull.vue";

export default {
  data() {
    return {
      navBlock: "活動 / 活動列表 ",
      navtitle: "活動抽簽",
      activeTab: "1",
      drawDetail: {
        applyName: "",
        beSelectedNumber: 0,
        notSelectedNumber: 0
      }
    };
  },
  // created() {
  //   this.$bus.$on("activityDrawinitList", () => {
  //     this.activeTab = "1";
  //   });
  // },
  activated() {
    this.$bus.$on("activityDrawinitList", () => {
      this.activeTab = "1";
    });
  },
  destroyed() {},
  methods: {
    dataBack(e) {
      this.drawDetail = { ...e };
    }
  },
  components: {
    NavBar,
    ActivityConfirmVue,
    ActivityConfirmNullVue
  }
};
</script>

<style lang="less" scoped>
@import "./el_tabs.less";
.content {
  background-color: rgba(245, 245, 252, 1);
  .paddingContent {
    width: 100%;
    // overflow: auto;
    .activityDrawListHeader {
      display: flex;
      align-items: center;
      margin-bottom: 19px;
      .activityDrawListHeader_title {
        font-size: 20px;
        color: rgba(108, 61, 234, 1);
        line-height: 26px;
        white-space: nowrap;
        overflow: hidden;
        max-width: calc(100vw - 920px);
        text-overflow: ellipsis;
      }
      .activityDrawListHeader_detail {
        display: flex;
        align-items: center;
        margin-left: 50px;
        .activityDrawListHeader_detail_key {
          margin-left: 24px;
          font-size: 14px;
          color: rgba(147, 142, 164, 1);
        }
        .activityDrawListHeader_detail_value {
          font-size: 14px;
          color: rgba(41, 41, 41, 1);
        }
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .paddingContent {
    min-width: 1210px;
  }
}
@media screen and (max-width: 769px) {
  .paddingContent {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activityDrawConfirmList.vue